package com.kinoshazam

actual fun defaultLocalApiHost(): String = "localhost"
